export default __webpack_public_path__ + "static/media/Honored Fauld of the Far Horizon.f0bf87f4.jpg";